import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from '../../../utils/translationMessages';
import './styles.css';

class DetailsManufacturer extends PureComponent {
  render() {
    const {
      intl: { formatMessage: t },
      manufacturerMakeLogo,
      findDealerLink,
      make,
      onClick,
      brandId,
      tracking,
    } = this.props;

    const onClickProps = onClick && {
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();

        tracking.clearEcommerceData();
        tracking.setGenericEvent('open modal', 'click', '', '', 'find a dealer', `brandID,${brandId}`);
      }
    };

    return (
      <div className="details-manufacturer">
        <div className="manufacturer-area">
          <div className="logo"><img src={manufacturerMakeLogo} alt={make} /></div>
          <div className="button">
            <a href={findDealerLink} target="blank">
              <button
                type="button"
                className="btn-action dealer-button" {...onClickProps}>
                {t(messages.detailsManufacturer.findDealerButton)}
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

DetailsManufacturer.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  manufacturerMakeLogo: PropTypes.string.isRequired,
  findDealerLink: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  brandId: PropTypes.number,
  tracking: PropTypes.shape({
    setGenericEvent: PropTypes.func.isRequired,
    clearEcommerceData: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(DetailsManufacturer);
